import { useEffect, useState } from "react";
import { useLike } from "../../hooks/useLike";
import { useResponsive } from "../../hooks/useResponsive";
import { BackBtn } from "../button/BackBtn";
import { IcBtnSm } from "../button/IcBtn";
import { HeaderCartBtn } from "../heading/HeaderCartBtn";
import {
  icBackArrowBlack,
  icCart,
  icCartOutline,
  icLovedOutline,
  icLoveOutline,
  icLoveOutlineBlack,
  icShareOutline,
  icShareOutlineBlack,
} from "../image/image-src";
import clsx from "clsx";

export const SmProductHeader = ({ d }: { d?: ProductDetailResponse }) => {
  const responsive = useResponsive();

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50); // scroll quá 50px thì đổi màu
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (responsive.isTabletLg) return null;
  return (
    <div
      className={clsx(
        "fixed inset-0 left-0 top-0 z-50 flex max-h-max w-full flex-col p-4 transition-colors duration-300 ease-in-out",
        scrolled ? "border-b border-gray-200 bg-white" : "sd-bg-prod-header",
      )}
    >
      {/* h-[6.25rem] */}
      <div className="flex justify-between">
        {/* left */}
        <div className="flex">
          <BackBtn ic={scrolled ? icBackArrowBlack : undefined} />
        </div>
        {/* right */}
        <div className="flex gap-4">
          <TtShareBtn ic={scrolled ? icShareOutlineBlack : icShareOutline} />
          <TtLikeBtn
            id={d?.id}
            ic={scrolled ? icLoveOutlineBlack : icLoveOutline}
          />
          <HeaderCartBtn ic={scrolled ? icCart : icCartOutline} />
        </div>
      </div>
    </div>
  );
};
const TtLikeBtn: React.FC<{
  ic?: string;
  id?: number;
}> = ({ id, ic }) => {
  const { handleLike, like } = useLike(id);
  return (
    <IcBtnSm
      onClick={handleLike}
      ic={like ? icLovedOutline : ic || icLoveOutline}
    />
  );
};

const TtShareBtn = ({ ic }: { ic?: string }) => {
  const handleShare = async () => {
    const url = window.location.href;

    if (navigator.share) {
      try {
        await navigator.share({
          title: document.title,
          url,
        });
      } catch (err) {
        console.error("Share failed:", err);
      }
    } else {
      await navigator.clipboard.writeText(url);
    }
  };

  return <IcBtnSm ic={ic || icShareOutline} onClick={handleShare} />;
};
